import '@/shared/assets/css/main.css'
import '@/help-seeker/mocks/setup.ts'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/help-seeker/App.vue'
import {
	fluent,
	setLocalization,
} from '@/help-seeker/localization/localization.ts'
import router from '@/help-seeker/router/router.ts'
import { api, ApiError } from '@/shared/api/api.ts'
import type { HelpSeeker } from '@/types/api.types.ts'
import { logout } from '@/utilities/logout.ts'

// Fetch the current user and store it globally so we can rely on an always-available user object.
const result = await api.request<HelpSeeker>(`online-users/me`)
if (result.status === 'ok') {
	globalThis.user = result.data

	// Initialize the Vue app and all its parts _after_ we've set `globalThis.user` so that it's value is available (1) when creating the global store (where it's used) and (2) when access the global store in route records.
	const app = createApp(App)

	setLocalization('de')

	app.use(createPinia())
	app.use(router)
	app.use(fluent)

	app.mount('#app')
} else if (result.error instanceof ApiError) {
	logout(window.location.href, true)
} else {
	throw result.error
}
